import React, { FC, useContext, useEffect, useLayoutEffect } from 'react';
import noop from 'lodash/noop';
import { get } from 'object-path';
import { Location } from 'history';

import useToLogin from '../../hooks/useToLogin';
import { history } from '../../app/history';
import { EventPage } from '../../pages/event';
import { TicketDistroContext } from '../../app/contexts';
import { TicketNotAvailable } from '../component-not-found';

interface AccessTokenProps {
  match: {
    params: {
      accessToken: string;
    };
  };
  location: Location;
}

export const AccessTokenLogin: FC<AccessTokenProps> = ({ match, location }: AccessTokenProps) => {
  const { ticketDistroContext } = useContext(TicketDistroContext);
  const isLoggedIn = useToLogin({ params: match && match.params, treatInvalidTokenAsUnavailable: true });
  const setState = get(ticketDistroContext, 'actions.setState', noop);
  const ticketNoLongerAvailable = get(ticketDistroContext, 'state.ticketNoLongerAvailable', false);

  // Reset ticketNoLongerAvailable when navigating between different access tokens
  // This allows fresh login attempts for each new token in the same SPA session
  useLayoutEffect(() => {
    setState({ ticketNoLongerAvailable: false });
  }, [match.params.accessToken, setState]);

  useEffect(() => {
    if (isLoggedIn) {
      if (location.search.includes('walkUpMode=1')) {
        setState({
          walkUpMode: true,
        });
      }
      history.push('/');
    }
  }, [isLoggedIn, location, setState]);

  // Show 404 page if ticket is no longer available (revoked)
  if (ticketNoLongerAvailable) {
    return <TicketNotAvailable />;
  }

  return <EventPage />;
};
